import React from 'react';
import {Link} from 'react-router-dom';

function Page404(props) {
    return (
        <div className="container mt-5">
        <div className="row">
            <div className="col-md-12">
                <div className="error-template">
                    <h1>
                        Oops!</h1>
                    <h2>
                        404 Not Found</h2>
                    <div className="error-details mt-3">
                        Sorry, an error has occured,the requested URL<strong>{` https://nguyenvantien-dev.web.app${props.location.pathname} `}</strong>was not found!
                    </div>
                    <div className="error-actions mt-3">
                        <Link to="/" className="btn btn-primary btn-lg"><i className="fas fa-home"></i>
                            Take Me Home </Link><Link to="/" className="btn btn-info ml-2 btn-lg"><i className="fas fa-envelope"></i> Contact Support </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    );
}

export default Page404;